import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Toolbar,
  Divider,
  TextField,
  Menu,
  Tooltip,
  MenuItem, useMediaQuery, useTheme,
  Button,
  InputAdornment,
  IconButton,
  Chip
} from "@mui/material";
import moment from "moment";
import Candidatejobslist from "./Candidatejobslist";
import Jobdetailsview from "../Benchcandidates/Jobdetailsview";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import Key from "../../clientVariables.json";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../Components/user-redux/selector";
import {
  candidateSelectedResumeAction,
  getJobtypeFilteredIDS,
  removeJobtypeFilter,
} from "../redux/action";
import { appSelector } from "../redux/selector";
import { ArrowBack, LocationCityOutlined, SearchOff } from "@mui/icons-material";

const AllTab = ({ onSelectJob, job = [] }) => {
  // Default to empty array
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(0);
  const [selectedResume, setSelectedResume] = useState();
  const [showJobDetails, setShowJobDetails] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [selectedDayFilter, setSelectedDayFilter] = useState(""); // New state for filter
  const [selectedFilterLabel, setSelectedFilterLabel] = useState(""); // State for filter label
  const [anchorElement, setAnchorElement] = useState(null);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const { user } = useSelector(userSelector);
  const [resumes, setResumes] = useState();
  const [selectedJobtypeFilter, setSelectedJobtypeFilter] = useState(""); // New state for filter
  const { candidateDetails } = useSelector(appSelector);
  const [jobsPostedLast24Hours, setJobsPostedLast24Hours] = useState(0);
  const { solrJobs, jobs_daycount } = useSelector(appSelector);
  const [jobSelectForMobileView, setJobSelectForMobileView] = useState(false);
  const [Jobs24hrsCount, setJobs24hrsCount] = useState(0);
  const [isLocationSearchActive, setIsLocationSearchActive] = useState(false);
  const [locationSearchTerm, setLocationSearchTerm] = useState("");
  const [noJobsFound, setNoJobsFound] = useState(false); // New state to track if no jobs found

  const handleJobCountChange = (count) => {
    setJobsPostedLast24Hours(count);
  };

  // Open the menu by setting the anchor element
  const openMenu = (event) => {
    setAnchorElement(event.currentTarget);
  };

  // Close the menu by resetting the anchor element
  const closeMenu = () => {
    setAnchorElement(null);
  };

  // Handle back button click for "No jobs found" view
  const handleBackFromNoJobs = () => {
    setNoJobsFound(false);
    setSelectedJobtypeFilter(""); // Reset job type filter
    dispatch(removeJobtypeFilter()); // Remove filter in redux
  };

  // Handle selection of menu item
  const handleSelection = async (type) => {
    // Implement your logic for the selected item
    const body = {
      jobtype: type,
      candidate_id: candidateDetails?.candidate_id,
    };
    await dispatch(getJobtypeFilteredIDS(body));
    setSelectedJobtypeFilter(type);

    // Set noJobsFound to true if Full-Time is selected
    setNoJobsFound(type === "Full-Time");

    //console.log(`Selected: ${type}`);
    closeMenu();
  };

  const handleListItemClick = (index) => {
    setSelectedItem(index);
  };

  const handleSearchChange = (event) => {
    dispatch(removeJobtypeFilter());
    setSearchTerm(event.target.value);
    // Reset no jobs found state when searching
    setNoJobsFound(false);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterOptionClick = (option) => {
    setSelectedDayFilter(option); // Update filter state

    // Set the filter label based on the selected option
    if (option === "1") {
      setSelectedFilterLabel("1 Day");
    } else if (option === "3") {
      setSelectedFilterLabel("3 Days");
    } else if (option === "7") {
      setSelectedFilterLabel("7 Days");
    }

    dispatch(removeJobtypeFilter());
    // Reset no jobs found state when filtering
    setNoJobsFound(false);
    handleFilterClose();
  };

  const handleLocationIconClick = () => {
    setIsLocationSearchActive(!isLocationSearchActive);
    if (isLocationSearchActive) {
      setLocationSearchTerm(""); // Clear the search term when closing
    }
  };

  const handleLocationSearchChange = (event) => {
    dispatch(removeJobtypeFilter());
    setLocationSearchTerm(event.target.value);
    // Reset no jobs found state when searching location
    setNoJobsFound(false);
  };

  const yesterdayStart = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DDTHH:mm:ss");

  const todayEnd = moment()
    .format("YYYY-MM-DDTHH:mm:ss");

  const filteredJobs24hrs = solrJobs?.filter((job) => {
    const postedDate = moment(job.posted_date)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    if (!moment(job.posted_date).isValid()) {
      console.error("Invalid date:", job.posted_date);
      return false;
    }
    return moment(job.posted_date).isBetween(
      yesterdayStart,
      todayEnd,
      null,
      "[]"
    );
  });

  // Memoize filtered jobs to optimize performance
  const filteredJobs = useMemo(() => {
    if (!Array.isArray(job)) return [];

    return job.filter((job) => {
      const matchesSearch = job.title
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      let matchesFilter = true;
      if (selectedDayFilter === "1") {
        matchesFilter = job.datePosted <= 1;
      } else if (selectedDayFilter === "3") {
        matchesFilter = job.datePosted <= 3;
      } else if (selectedDayFilter === "7") {
        matchesFilter = job.datePosted <= 7;
      }

      let matchesLocation = true;
      if (locationSearchTerm) {
        matchesLocation = job.location?.toLowerCase() === locationSearchTerm.toLowerCase();
      }

      return matchesSearch && matchesFilter && matchesLocation;
    });
  }, [searchTerm, selectedDayFilter, locationSearchTerm, job]);

  const theme = useTheme();
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const isDesktopExtraSmall = useMediaQuery('(min-width: 992px) and (max-width: 1199px)');
  const isDesktopMedium = useMediaQuery('(min-width: 1440px) and (max-width: 1919px)');

  const jobMobileViewHandler = (isJobSelect) => {
    setJobSelectForMobileView(isJobSelect);
  };

  const paperStyles = {
    borderRadius: "8px",
    height: "100%",
    overflow: "hidden",
    padding: "5px",
    display: "flex",
    flexDirection: "column"
  };

  // If no jobs found (Full-Time selected), show professional "No jobs found" message with back button
  if (noJobsFound) {
    return (
      <Box
        sx={{
          border: "1px solid lightgray",
          borderRadius: "5px",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 3
        }}
      >
        <SearchOff sx={{ fontSize: 60, color: "#9e9e9e", mb: 2 }} />
        <Typography variant="h5" sx={{ color: "#424242", mb: 1, fontWeight: 500 }}>
          No matching jobs found
        </Typography>
        <Typography variant="body1" sx={{ color: "#757575", mb: 3, textAlign: "center" }}>
          We couldn't find any {selectedJobtypeFilter} positions that match your criteria.
        </Typography>
        <Button
          variant="contained"
          onClick={handleBackFromNoJobs}
          startIcon={<ArrowBack />}
          sx={{
            backgroundColor: "#406882",
            '&:hover': { backgroundColor: "#335571" },
            textTransform: "none",
            px: 3
          }}
        >
          Return to Available Jobs
        </Button>
      </Box>
    );
  }

  // Normal render with both grids
  return (
    <Box
      sx={{
        //border: "1px solid lightgray",
        borderRadius: "5px",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Grid container sx={{ flexGrow: 1, height: "100%", margin: 0, width: "100%" }}>
        <Grid item xs={isMobile || isMobileSmall || isTablet ? 12 : isDesktopSmall ? 4 : isDesktopLarge ? 3.2 : 3.2}
          sx={{
            display: isDesktop || jobSelectForMobileView ? 'block' : 'none',
            height: "100%",
            pt: "0 !important",
            pr: { xs: 0, md: 1 },
            pb: { xs: 1, md: 0 },
          }}
        >
          <Paper elevation={2} sx={paperStyles}>
            <Toolbar
              sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                position: "sticky",
                minHeight: "48px !important",
                bgcolor: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1
              }}
            >
              {/* Job Title Search */}
              <TextField
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search Job Title"
                variant="outlined"
                size="small"
                sx={{
                  flex: 1,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '4px',
                    backgroundColor: '#f5f5f5',
                    '&:hover': {
                      backgroundColor: '#f0f0f0',
                    },
                    '&.Mui-focused': {
                      backgroundColor: '#ffffff',
                    }
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#696969" }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={clearSearch}
                        size="small"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box sx={{ display: "flex", alignItems: "center" }}>
                {/* Location Search Button */}
                <Tooltip title={isLocationSearchActive ? "Close location search" : "Search by Location"}>
                  <LocationOnOutlinedIcon
                    sx={{
                      color: locationSearchTerm ? "#406882" : "#696969",
                      cursor: "pointer",
                      "&:hover": {
                        color: "#406882",
                      },
                      fontSize: "20px",
                    }}
                    onClick={handleLocationIconClick}
                  />
                </Tooltip>

                {/* Filter Button */}
                <Tooltip title="Filter Jobs">
                  <FilterListOutlinedIcon
                    onClick={handleFilterClick}
                    sx={{
                      cursor: "pointer",
                      marginLeft: "10px",
                      color: selectedDayFilter ? "#406882" : "#696969",
                      "&:hover": {
                        color: "#406882",
                      },
                    }}
                  />
                </Tooltip>
              </Box>
            </Toolbar>

            {/* Location Search Field - Only visible when active */}
            {isLocationSearchActive && (
              <Box sx={{ px: 2, py: 1, borderTop: "1px solid #f0f0f0" }}>
                <TextField
                  value={locationSearchTerm}
                  onChange={handleLocationSearchChange}
                  placeholder="Search Location"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '4px',
                      backgroundColor: '#f5f5f5',
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationOnOutlinedIcon sx={{ color: "#696969", fontSize: "18px" }} />
                      </InputAdornment>
                    ),
                    endAdornment: locationSearchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => setLocationSearchTerm("")}
                          size="small"
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            )}

            {/* Filter Chip */}
            {selectedFilterLabel && (
              <Box sx={{ px: 2, py: 1 }}>
                <Chip
                  label={selectedFilterLabel}
                  onDelete={() => {
                    setSelectedDayFilter("");
                    setSelectedFilterLabel("");
                  }}
                  color="primary"
                  size="small"
                  sx={{
                    backgroundColor: "#406882",
                    '&:hover': { backgroundColor: "#335571" }
                  }}
                />
              </Box>
            )}

            <Menu
              anchorEl={filterAnchorEl}
              open={Boolean(filterAnchorEl)}
              onClose={handleFilterClose}
            >
              <MenuItem onClick={() => handleFilterOptionClick("1")}>
                <Typography variant="body2">1 Day</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleFilterOptionClick("3")}>
                <Typography variant="body2">3 Days</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleFilterOptionClick("7")}>
                <Typography variant="body2">7 Days</Typography>
              </MenuItem>
            </Menu>

            <Divider />

            <Box sx={{ flexGrow: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
              <Candidatejobslist
                onSelectJob={onSelectJob}
                searchTerm={searchTerm}
                locationSearchTerm={locationSearchTerm}
                selectedDayFilter={selectedDayFilter}
                jobs={filteredJobs} // Pass filtered jobs to the list
                onSearchChange={handleSearchChange}
                selectedJobtypeFilter={selectedJobtypeFilter}
                jobMobileViewHandler={jobMobileViewHandler}
              />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={isDesktopSmall || isDesktopExtraSmall ? 8 : isDesktopLarge || isDesktopMedium ? 8.8 : isMobile || isMobileSmall || isTablet ? 12 : 8.8} sx={{ display: !jobSelectForMobileView ? 'block' : "none", height: "100%", pt: "0 !important" }}>
          <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box>
              <Button
                onClick={() => jobMobileViewHandler(true)}
                sx={{
                  display: { xs: 'flex', sm: 'flex', md: 'none' },
                  justifyContent: 'flex-end',
                  marginBottom: '10px',
                  width: '100%', // Make the button take up full width for mobile
                }}
              >
                <ArrowBack /> &nbsp;Back
              </Button>
            </Box>

            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
              <Jobdetailsview job={selectedJob} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AllTab;